import React from 'react';
export default function CircleSuitJacket({ baseColor, lapelColor }) {
  return (
<><path d="M14.279 24.308l1.576 12.711-13.835-.062 2.863-11.552zM20.135 24.308L18.56 37.02l13.835-.062-2.862-11.552z" fill={baseColor}/><path d="M14.279 24.308l-1.42.164-2.054 5.33 1.66 1.223-1.494 1.12 2.862 8.317 2.458.104zM20.1 24.308l1.421.164 2.053 5.33-1.659 1.223 1.494 1.12-2.862 8.317-2.458.104z" fill={lapelColor}/></>); }
